import { SnackState } from './snack.types'

export const state: SnackState = {
  snack: {}
}
